import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GridApi } from "ag-grid-community";

const globalGridApiSlice = createSlice({
    name: "globalGridApi",
    initialState: { value: {} },
    reducers: {
        setGlobalGridApi: (state, action: PayloadAction<GridApi>) => {
            state.value = action.payload;
        },
    },
});

export const { setGlobalGridApi } = globalGridApiSlice.actions;
export const globalGridApiReducer = globalGridApiSlice.reducer;
